module.exports = __webpack_public_path__ + "public/images/program/program-14.0d604d7051505e9455bcbc400c579b22.jpg";